import { InitCookie } from '@patsnap/init-cookie';

const PRODUCT_SOURCE = 'eureka_ls';

export class InitCookieService {
    private _cookieInstance: InitCookie | null = null;

    private get hash() {
        return window.location.hash.replace(/^#/, '');
    }

    private get pathname() {
        return this.hash.split('?')[0];
    }

    private get query() {
        return new URLSearchParams(this.hash.split('?')[1]);
    }

    private isHomePage() {
        return this.pathname === '/home' || this.pathname === '/';
    }

    get agentSource() {
        return this.query.get('start_from');
    }

    getRouteEntryChannel() {
        if (/\/ai-ls\/document-agent/.test(this.pathname)) {
            return 'ls_pda';
        }

        if (this.pathname === '/home/sar' || /\/ai-ls\/sar(-share)?\//.test(this.pathname)) {
            return 'ls_sar';
        }

        if (/^.*\/ai\/agent-flow\/[^/]+$/.test(this.pathname)) {
            const agent = this.query?.get('agent')?.trim();
            return agent ? `ls_${agent.toLowerCase()}` : 'ls_agent';
        }

        if (this.isHomePage()) {
            const agent = this.query?.get('agent')?.trim() || 'lca';
            return `ls_${agent.toLowerCase()}`;
        }

        return undefined;
    }

    async init() {
        const entry_channel = this.getRouteEntryChannel();
        if (!entry_channel) return;
        this._cookieInstance = new InitCookie({
            entry_channel,
            campaign_name: this.query?.get('from')?.trim() || undefined,
        });
        return await this._cookieInstance.init();
    }

    getCampaignName() {
        return InitCookie.getCampaignName();
    }

    getEntryChannel() {
        return InitCookie.getEntryChannel();
    }

    getVisitorId() {
        return InitCookie.getVisitorId();
    }

    getProductSource() {
        return this.agentSource === 'eureka_ls_landingpage' ? 'eureka_ls_landingpage' : (this.getRouteEntryChannel() ?? PRODUCT_SOURCE);
    }

    getSupplyPermissionParams() {
        return {
            entry_channel: this.getEntryChannel(),
            visitor_id: this.getVisitorId(),
            product_source: this.getProductSource(),
            source: this.getCampaignName(),
        }
    }
}

export const initCookieService = new InitCookieService();
